import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import de from "./locales/de";
import en from "./locales/en";
import nl from "./locales/nl";
import deCH from "./locales/de-CH";
import deAT from "./locales/de-AT";
import nlBE from "./locales/nl-BE";
import frBE from "./locales/fr-BE";
import wa from "./locales/wa";
import fr from "./locales/fr";
import pl from "./locales/pl";

/* ── Locale ↔ URL-prefix mapping ── */
export const LOCALE_PREFIXES = [
  { prefix: "de", locale: "de-DE", i18nCode: "de", label: "Deutschland", flag: "🇩🇪" },
  { prefix: "at", locale: "de-AT", i18nCode: "de-AT", label: "Österreich", flag: "🇦🇹" },
  { prefix: "ch", locale: "de-CH", i18nCode: "de-CH", label: "Schweiz", flag: "🇨🇭" },
  { prefix: "nl", locale: "nl-NL", i18nCode: "nl", label: "Nederland", flag: "🇳🇱" },
  { prefix: "be-nl", locale: "nl-BE", i18nCode: "nl-BE", label: "België (NL)", flag: "🇧🇪" },
  { prefix: "be-fr", locale: "fr-BE", i18nCode: "fr-BE", label: "Belgique (FR)", flag: "🇧🇪" },
  { prefix: "wa", locale: "wa", i18nCode: "wa", label: "Walon", flag: "🇧🇪" },
  { prefix: "fr", locale: "fr-FR", i18nCode: "fr", label: "France", flag: "🇫🇷" },
  { prefix: "pl", locale: "pl-PL", i18nCode: "pl", label: "Polska", flag: "🇵🇱" },
  { prefix: "en", locale: "en-GB", i18nCode: "en", label: "English", flag: "🇬🇧" },
] as const;

/** Backward-compatible alias */
export const LANGUAGES = LOCALE_PREFIXES;

export type LocalePrefix = (typeof LOCALE_PREFIXES)[number];

/** Get the URL prefix for an i18n language code */
export function getLocalePrefixFromI18n(i18nCode: string): string {
  return LOCALE_PREFIXES.find((p) => p.i18nCode === i18nCode)?.prefix || "de";
}

/** Get the i18n code for a URL prefix */
export function getI18nCodeFromPrefix(prefix: string): string {
  return LOCALE_PREFIXES.find((p) => p.prefix === prefix)?.i18nCode || "de";
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      nl: { translation: nl },
      "de-CH": { translation: deCH },
      "de-AT": { translation: deAT },
      "nl-BE": { translation: nlBE },
      "fr-BE": { translation: frBE },
      wa: { translation: wa },
      fr: { translation: fr },
      pl: { translation: pl },
    },
    fallbackLng: "de",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "craftfindus_lang",
    },
  });

export default i18n;
